import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments';
import { ApiBaseService } from './api-base.service';

@Injectable({
  providedIn: 'root',
})
export class ApiFollowService extends ApiBaseService {
  protected apiBaseUrl = environment.apiUrl;
  protected routePath = `follow/v2/`; // : string;

  constructor(private _httpClient: HttpClient) {
    super(_httpClient);
  }

  public sendInviteCode(inviteCode: string): Promise<void> {
    const path = `invite-code`;
    return super.post<void>(path, { inviteCode });
  }
}
